<template>
<div class="container py-5">
  <h1>Términos y Condiciones</h1>
  <p>Última actualización: 28 de abril de 2025</p>

  <h2>1. Aceptación de los Términos</h2>
  <p>Al acceder y utilizar el servicio proporcionado por <strong>Medicynia</strong>, usted acepta quedar obligado por estos Términos y Condiciones de Uso, así como por nuestras políticas de privacidad y las leyes aplicables. Si no está de acuerdo con alguna parte de los términos, no debe utilizar el servicio.</p>

  <h2>2. Descripción del Servicio</h2>
  <p><strong>Medicynia</strong> es una plataforma en línea tipo <em>Software as a Service (SaaS)</em> que permite a profesionales de la salud en México gestionar expedientes clínicos electrónicos de manera segura y conforme a la <strong>NOM-004-SSA3-2012</strong>. Entre sus funcionalidades se encuentran: creación de notas médicas, gestión de citas, antecedentes médicos, tratamientos, consentimiento informado, almacenamiento de documentos clínicos y control de agenda médica.</p>

  <h2>3. Cuentas de Usuario</h2>
  <p>El usuario debe registrar una cuenta proporcionando información veraz y actualizada. Es responsabilidad del usuario mantener la confidencialidad de sus credenciales, notificar cualquier acceso no autorizado y asumir la responsabilidad de todas las actividades realizadas bajo su cuenta. <strong>Medicynia</strong> no será responsable por pérdidas o daños derivados del incumplimiento de esta obligación.</p>

  <h2>4. Uso Aceptable</h2>
  <p>El usuario se compromete a utilizar <strong>Medicynia</strong> únicamente para fines médicos profesionales conforme a las leyes mexicanas. Se prohíbe utilizar el sistema para actividades ilegales, fraudulentas, o para almacenar contenido prohibido. Nos reservamos el derecho de suspender o cancelar cuentas que incumplan estas disposiciones.</p>

  <h2>5. Propiedad Intelectual</h2>
  <p>Todos los derechos de propiedad intelectual sobre la plataforma, contenidos, bases de datos, logotipos, diseños y funcionalidades pertenecen a <strong>Medicynia</strong> o se encuentran licenciados para su uso. No se otorga ningún derecho de propiedad intelectual al usuario más allá del acceso limitado al servicio conforme a estos términos.</p>

  <h2>6. Pagos y Suscripciones</h2>
  <p>El acceso a ciertas funcionalidades de <strong>Medicynia</strong> está sujeto al pago de una suscripción mensual o anual, según el plan contratado. Las suscripciones se renuevan automáticamente salvo que el usuario solicite la cancelación antes del siguiente periodo de facturación. Los pagos no son reembolsables. Nos reservamos el derecho de actualizar los precios previo aviso razonable.</p>

  <h2>7. Limitación de Responsabilidad</h2>
  <p><strong>Medicynia</strong> es un sistema de apoyo administrativo-clínico que no sustituye el juicio médico profesional. No nos hacemos responsables por decisiones clínicas, pérdidas de datos por causas externas, ni daños indirectos derivados del uso del sistema. El uso de Medicynia es bajo la responsabilidad exclusiva del usuario.</p>

  <h2>8. Modificaciones a los Términos</h2>
  <p>Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios serán publicados en la plataforma y su uso continuo del servicio después de dichas modificaciones constituirá su aceptación a los nuevos términos.</p>

  <h2>9. Ley Aplicable</h2>
  <p>Estos Términos y Condiciones se regirán e interpretarán conforme a las leyes de los Estados Unidos Mexicanos. Cualquier disputa será resuelta ante los tribunales competentes de la Ciudad de México.</p>

  <h2>10. Contacto</h2>
  <p>Para cualquier duda, aclaración o solicitud relacionada con estos Términos y Condiciones, puede contactarnos en: <strong>contacto@medicynia.com</strong></p>
</div>

</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'TermsConditionsView',
  setup() {
    useHead({
      title: 'Términos y Condiciones | Medicynia',
      meta: [
        { name: 'description', content: 'Consulta los términos y condiciones de uso de Medicynia. Información legal y obligaciones para usuarios de la plataforma.' },
        { property: 'og:title', content: 'Términos y Condiciones | Medicynia' },
        { property: 'og:description', content: 'Consulta los términos y condiciones de uso de Medicynia. Información legal y obligaciones para usuarios de la plataforma.' },
        { property: 'og:type', content: 'article' },
        { property: 'og:url', content: 'https://medicynia.com/terms-conditions' },
        { property: 'og:image', content: 'https://medicynia.com/logo-main.webp' },
        { name: 'robots', content: 'index, follow' }
      ],
      link: [
        { rel: 'canonical', href: 'https://medicynia.com/terms-conditions' }
      ]
    })
  }
}
</script>

<style scoped>
/* Add styles if needed */
h1 {
  margin-bottom: 1rem;
}
h2 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
p {
  line-height: 1.6;
}
</style>